export default {"src":"/_next/static/media/NotPlayable.baffa458.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};